// extracted by mini-css-extract-plugin
module.exports = {"text":"SQoV8","input-text":"pFY11","form-group":"ef4RD"};